(() => {
  const PANEL_SELECTOR = '[data-egifts-cart-same-design]';
  const ARTWORK_SELECTOR = '[data-egifts-cart-artwork]';
  const EDIT_SELECTOR = '.tee-edit-customization';
  const TEE_ARTWORK_SELECTOR = 'svg.tee-mockup-artwork';
  const VERSION = '8.1';

  if (window.EgiftsSameDesignCartV81) {
    window.EgiftsSameDesignCartV81.initAll();
    return;
  }

  let pendingEdit = null;
  let editCaptureTimer = null;
  let reconcileTimer = null;
  let mutationTimer = null;
  let internalMutation = false;

  const storageKey = (customizationId) => `egifts-sd-artwork:${customizationId}`;

  const cartJsonUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart.js`.replace(/\/{2,}/g, '/');
  };

  const cartAddUrl = () => {
    if (window.routes?.cart_add_url) return window.routes.cart_add_url;
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/add.js`.replace(/\/{2,}/g, '/');
  };

  const cartChangeUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/change.js`.replace(/\/{2,}/g, '/');
  };

  const getProperties = (item) => {
    return item && typeof item.properties === 'object' && item.properties ? item.properties : {};
  };

  const isAddon = (item) => String(getProperties(item)._egifts_same_design || '') === '1';

  const isMainPersonalizedItem = (item) => {
    const props = getProperties(item);
    return Boolean(props._customization_id && !isAddon(item));
  };

  const fetchCart = async () => {
    const response = await fetch(cartJsonUrl(), {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cache: 'no-store'
    });

    if (!response.ok) throw new Error(`Cart HTTP ${response.status}`);
    return response.json();
  };

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const serializeVisibleTeeArtwork = () => {
    const svgs = Array.from(document.querySelectorAll(TEE_ARTWORK_SELECTOR)).filter(isVisible);
    if (!svgs.length) return '';

    svgs.sort((a, b) => {
      const ar = a.getBoundingClientRect();
      const br = b.getBoundingClientRect();
      return br.width * br.height - ar.width * ar.height;
    });

    const clone = svgs[0].cloneNode(true);
    clone.querySelectorAll('script').forEach((node) => node.remove());

    [clone, ...clone.querySelectorAll('*')].forEach((node) => {
      Array.from(node.attributes || []).forEach((attribute) => {
        if (/^on/i.test(attribute.name)) node.removeAttribute(attribute.name);
      });
    });

    clone.removeAttribute('width');
    clone.removeAttribute('height');
    clone.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    try {
      return new XMLSerializer().serializeToString(clone);
    } catch (error) {
      return '';
    }
  };

  const safeSvgFromString = (svgString) => {
    if (!svgString) return null;

    try {
      const doc = new DOMParser().parseFromString(svgString, 'image/svg+xml');
      const svg = doc.documentElement;

      if (!svg || svg.nodeName.toLowerCase() !== 'svg') return null;

      svg.querySelectorAll('script').forEach((node) => node.remove());

      [svg, ...svg.querySelectorAll('*')].forEach((node) => {
        Array.from(node.attributes || []).forEach((attribute) => {
          if (/^on/i.test(attribute.name)) node.removeAttribute(attribute.name);
        });
      });

      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.width = '100%';
      svg.style.height = '100%';
      svg.style.display = 'block';
      svg.style.pointerEvents = 'none';

      return document.importNode(svg, true);
    } catch (error) {
      return null;
    }
  };

  const renderFallbackImage = (container, url) => {
    if (!url) return;

    const image = document.createElement('img');
    image.alt = '';
    image.loading = 'lazy';
    image.referrerPolicy = 'no-referrer';
    image.src = url;
    image.addEventListener('error', () => image.remove());

    container.replaceChildren(image);
  };

  const renderArtwork = (container) => {
    const customizationId = container.dataset.customizationId || '';

    if (customizationId) {
      try {
        const stored = window.localStorage.getItem(storageKey(customizationId));
        const svg = safeSvgFromString(stored);

        if (svg) {
          internalMutation = true;
          container.replaceChildren(svg);
          window.setTimeout(() => {
            internalMutation = false;
          }, 0);
          return;
        }
      } catch (error) {}
    }

    // Brak zapisanej warstwy projektu: zostawiamy czysty mockup dodatku.
    // _customization_image jest podglądem całego produktu, a nie samym artworkiem,
    // więc nie wolno nakładać go na kubek/poduszkę jako warstwy nadruku.
    container.replaceChildren();
  };

  const initArtwork = (scope = document) => {
    scope.querySelectorAll(ARTWORK_SELECTOR).forEach((container) => {
      if (container.dataset.egiftsArtworkReady === 'true') return;
      container.dataset.egiftsArtworkReady = 'true';
      renderArtwork(container);
    });
  };

  const closePicker = (picker) => {
    if (!picker) return;

    const toggle = picker.querySelector('[data-egifts-cart-picker-toggle]');
    const menu = picker.querySelector('[data-egifts-cart-picker-menu]');

    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
  };

  const initPanel = (panel) => {
    if (!panel || panel.dataset.egiftsInitialized === 'true') return;
    panel.dataset.egiftsInitialized = 'true';

    panel.querySelectorAll('[data-egifts-cart-addon]').forEach((card) => {
      const picker = card.querySelector('[data-egifts-cart-picker]');
      const toggle = card.querySelector('[data-egifts-cart-picker-toggle]');
      const menu = card.querySelector('[data-egifts-cart-picker-menu]');
      const label = card.querySelector('[data-egifts-cart-picker-label]');
      const price = card.querySelector('[data-egifts-cart-addon-price]');
      const baseImage = card.querySelector('[data-egifts-cart-addon-base]');
      const preview = card.querySelector('.egifts-cart-sd-panel__preview');
      const addButton = card.querySelector('[data-egifts-cart-add]');

      if (picker && toggle && menu) {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const open = toggle.getAttribute('aria-expanded') !== 'true';

          panel.querySelectorAll('[data-egifts-cart-picker]').forEach((otherPicker) => {
            if (otherPicker !== picker) closePicker(otherPicker);
          });

          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          menu.hidden = !open;
        });

        menu.querySelectorAll('[data-egifts-cart-variant-option]').forEach((option) => {
          option.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            card.dataset.selectedVariantId = option.dataset.variantId || '';
            card.dataset.previewKey = option.dataset.previewKey || '';

            if (preview) preview.dataset.previewKey = option.dataset.previewKey || '';
            if (label) label.textContent = option.dataset.label || '';
            if (price && option.dataset.price) price.textContent = `+${option.dataset.price}`;
            if (baseImage && option.dataset.image) baseImage.src = option.dataset.image;

            menu.querySelectorAll('[data-egifts-cart-variant-option]').forEach((item) => {
              item.classList.toggle('is-current', item === option);
            });

            closePicker(picker);
          });
        });
      }

      if (addButton) {
        addButton.addEventListener('click', async (event) => {
          event.preventDefault();

          const variantId = card.dataset.selectedVariantId || '';
          if (!variantId || addButton.disabled) return;

          const status = panel.querySelector('[data-egifts-cart-status]');
          const family = card.dataset.family || '';
          const productId = card.dataset.productId || '';
          const previewKey = card.dataset.previewKey || '';
          const parentCustomizationId = panel.dataset.parentCustomizationId || '';
          const sourceProductId = panel.dataset.sourceProductId || '';
          const sourceProductTitle = String(panel.dataset.sourceProductTitle || '').trim();
          const checkoutPatternLabel = sourceProductTitle
            ? `Taki sam jak „${sourceProductTitle}”`
            : 'Taki sam jak na produkcie głównym';
          const sourceVariantId = panel.dataset.sourceVariantId || '';
          const sourceDesignUrl = panel.dataset.sourceDesignUrl || '';
          const sourcePreviewUrl = panel.dataset.sourcePreviewUrl || '';

          addButton.disabled = true;
          addButton.textContent = '…';

          if (status) {
            status.hidden = false;
            status.classList.remove('is-error');
            status.textContent = 'Dodaję do koszyka…';
          }

          try {
            const response = await fetch(cartAddUrl(), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1,
                    properties: {
                      'Wzór': checkoutPatternLabel,
                      _egifts_same_design: '1',
                      _egifts_same_design_version: VERSION,
                      _egifts_same_design_target: family,
                      _egifts_same_design_group: parentCustomizationId,
                      _egifts_parent_customization_id: parentCustomizationId,
                      _egifts_target_product_id: String(productId),
                      _egifts_target_variant_id: String(variantId),
                      _egifts_preview_key: previewKey,
                      _egifts_source_product_id: String(sourceProductId),
                      _egifts_source_variant_id: String(sourceVariantId),
                      _egifts_source_design_url: sourceDesignUrl,
                      _egifts_source_preview_url: sourcePreviewUrl
                    }
                  }
                ]
              })
            });

            if (!response.ok) {
              const data = await response.json().catch(() => ({}));
              throw new Error(data.description || data.message || `HTTP ${response.status}`);
            }

            window.location.reload();
          } catch (error) {
            addButton.disabled = false;
            addButton.textContent = '+';

            if (status) {
              status.hidden = false;
              status.classList.add('is-error');
              status.textContent = 'Nie udało się dodać produktu. Spróbuj ponownie.';
            }

            console.error('E-gifts cart same design:', error);
          }
        });
      }
    });

    document.addEventListener('click', (event) => {
      if (!panel.contains(event.target) || !event.target.closest('[data-egifts-cart-picker]')) {
        panel.querySelectorAll('[data-egifts-cart-picker]').forEach(closePicker);
      }
    });
  };

  const initAll = (scope = document) => {
    initArtwork(scope);
    scope.querySelectorAll(PANEL_SELECTOR).forEach(initPanel);
  };


  const syncPanelsWithCart = async () => {
    try {
      const cart = await fetchCart();

      document.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
        const parentCustomizationId = panel.dataset.parentCustomizationId || '';
        if (!parentCustomizationId) return;

        const addedFamilies = new Set(
          (cart.items || [])
            .filter((item) => {
              if (!isAddon(item)) return false;

              return (
                String(getProperties(item)._egifts_parent_customization_id || '') ===
                parentCustomizationId
              );
            })
            .map((item) => String(getProperties(item)._egifts_same_design_target || ''))
            .filter(Boolean)
        );

        panel.querySelectorAll('[data-egifts-cart-addon]').forEach((card) => {
          const family = card.dataset.family || '';
          card.hidden = addedFamilies.has(family);
        });

        const hasVisibleCard = Array.from(
          panel.querySelectorAll('[data-egifts-cart-addon]')
        ).some((card) => !card.hidden);

        panel.hidden = !hasVisibleCard;
      });
    } catch (error) {}
  };

  const scheduleReinit = () => {
    window.clearTimeout(mutationTimer);

    mutationTimer = window.setTimeout(() => {
      initAll(document);
      syncPanelsWithCart();
    }, 80);
  };

  const installCartObserver = () => {
    const target = document.querySelector('cart-items') || document.querySelector('#main-cart-items') || document.body;

    const observer = new MutationObserver((mutations) => {
      if (internalMutation) return;

      const structuralChange = mutations.some(
        (mutation) => mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0
      );

      if (structuralChange) scheduleReinit();
    });

    observer.observe(target, {
      subtree: true,
      childList: true
    });
  };

  const captureEditArtwork = () => {
    if (!pendingEdit) return;

    const svg = serializeVisibleTeeArtwork();
    if (svg) pendingEdit.latestArtwork = svg;
  };

  const startEditCapture = () => {
    window.clearInterval(editCaptureTimer);
    editCaptureTimer = window.setInterval(captureEditArtwork, 250);
  };

  const stopEditCapture = () => {
    window.clearInterval(editCaptureTimer);
    editCaptureTimer = null;
  };

  const changeItemProperties = async (item, properties) => {
    const response = await fetch(cartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,
        properties
      })
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.description || data.message || `HTTP ${response.status}`);
    }

    return response.json();
  };

  const beginEditTracking = async (wrapper) => {
    const oldCustomizationId = wrapper?.dataset?.customizationId || '';
    if (!oldCustomizationId) return;

    try {
      const cart = await fetchCart();
      const mainItems = (cart.items || []).filter(isMainPersonalizedItem);
      const oldMain = mainItems.find(
        (item) => String(getProperties(item)._customization_id || '') === oldCustomizationId
      );

      pendingEdit = {
        oldCustomizationId,
        oldMain,
        beforeIds: new Set(
          mainItems
            .map((item) => String(getProperties(item)._customization_id || ''))
            .filter(Boolean)
        ),
        latestArtwork: ''
      };

      captureEditArtwork();
      startEditCapture();
    } catch (error) {
      console.error('E-gifts edit tracking:', error);
    }
  };

  const resolveEditedMain = (cart) => {
    if (!pendingEdit) return null;

    const mainItems = (cart.items || []).filter(isMainPersonalizedItem);
    const oldId = pendingEdit.oldCustomizationId;

    const sameId = mainItems.find(
      (item) => String(getProperties(item)._customization_id || '') === oldId
    );

    if (sameId) return sameId;

    const newItems = mainItems.filter((item) => {
      const id = String(getProperties(item)._customization_id || '');
      return id && !pendingEdit.beforeIds.has(id);
    });

    if (newItems.length === 1) return newItems[0];

    const oldMain = pendingEdit.oldMain;

    if (oldMain) {
      const matches = mainItems.filter(
        (item) =>
          Number(item.product_id) === Number(oldMain.product_id) &&
          Number(item.variant_id) === Number(oldMain.variant_id)
      );

      if (matches.length === 1) return matches[0];
    }

    return null;
  };

  const migrateLinkedAddons = async (cart, newMain) => {
    if (!pendingEdit || !newMain) return;

    const oldId = pendingEdit.oldCustomizationId;
    const newProps = getProperties(newMain);
    const newId = String(newProps._customization_id || '');
    if (!newId) return;

    const newDesignUrl = String(newProps._tib_design_link_1 || newProps._tib_design_link || '');
    const newPreviewUrl = String(newProps._customization_image || '');

    const linked = (cart.items || []).filter((item) => {
      if (!isAddon(item)) return false;
      return String(getProperties(item)._egifts_parent_customization_id || '') === oldId;
    });

    for (const addon of linked) {
      const props = {
        ...getProperties(addon),
        _egifts_parent_customization_id: newId,
        _egifts_source_variant_id: String(newMain.variant_id || newMain.id || ''),
        _egifts_source_design_url: newDesignUrl,
        _egifts_source_preview_url: newPreviewUrl
      };

      await changeItemProperties(addon, props);
    }

    let artwork = pendingEdit.latestArtwork;

    if (!artwork) {
      try {
        artwork = window.localStorage.getItem(storageKey(oldId)) || '';
      } catch (error) {}
    }

    if (artwork) {
      try {
        window.localStorage.setItem(storageKey(newId), artwork);
      } catch (error) {}
    }

    document.querySelectorAll(`[data-egifts-cart-artwork][data-customization-id="${CSS.escape(oldId)}"]`).forEach(
      (node) => {
        node.dataset.customizationId = newId;
        node.dataset.egiftsArtworkReady = '';
      }
    );

    document.querySelectorAll(`${PANEL_SELECTOR}[data-parent-customization-id="${CSS.escape(oldId)}"]`).forEach(
      (panel) => {
        panel.dataset.parentCustomizationId = newId;
        panel.dataset.sourceVariantId = String(newMain.variant_id || newMain.id || '');
        panel.dataset.sourceDesignUrl = newDesignUrl;
        panel.dataset.sourcePreviewUrl = newPreviewUrl;
        panel.querySelectorAll('[data-egifts-cart-artwork]').forEach((node) => {
          node.dataset.previewUrl = newPreviewUrl;
          node.dataset.designUrl = newDesignUrl;
          node.dataset.egiftsArtworkReady = '';
        });
      }
    );

    initAll(document);
    await syncPanelsWithCart();
  };

  const reconcilePendingEdit = async (attempt = 0) => {
    if (!pendingEdit) return;

    try {
      const cart = await fetchCart();
      const newMain = resolveEditedMain(cart);

      if (!newMain) {
        if (attempt < 12) {
          reconcileTimer = window.setTimeout(() => reconcilePendingEdit(attempt + 1), 300);
        } else {
          stopEditCapture();
          pendingEdit = null;
        }
        return;
      }

      await migrateLinkedAddons(cart, newMain);

      stopEditCapture();
      pendingEdit = null;
      scheduleReinit();
    } catch (error) {
      if (attempt < 12) {
        reconcileTimer = window.setTimeout(() => reconcilePendingEdit(attempt + 1), 350);
      } else {
        console.error('E-gifts edit reconcile:', error);
        stopEditCapture();
        pendingEdit = null;
      }
    }
  };

  const scheduleEditReconcile = () => {
    if (!pendingEdit) {
      scheduleReinit();
      return;
    }

    captureEditArtwork();
    window.clearTimeout(reconcileTimer);
    reconcileTimer = window.setTimeout(() => reconcilePendingEdit(0), 450);
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      const wrapper = event.target.closest(EDIT_SELECTOR);
      if (!wrapper) return;
      beginEditTracking(wrapper);
    },
    true
  );

  document.addEventListener('teeinblue-event-customization-changed', captureEditArtwork);
  document.addEventListener('shopify-event-cart-modified', scheduleEditReconcile);
  document.addEventListener('shopify-event-cart-ajax', scheduleReinit);
  document.addEventListener('teeinblue-event-after-cart-added', scheduleReinit);

  window.EgiftsSameDesignCartV81 = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll();
      installCartObserver();
      syncPanelsWithCart();
    });
  } else {
    initAll();
    installCartObserver();
    syncPanelsWithCart();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
    scheduleReinit();
  });
})();